"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "m-m-t-8 comment"
  }, [_vm.showAdd ? _c("a-button", {
    attrs: {
      type: "link",
      icon: "form"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.handleCommentAdd();
      }
    }
  }, [_vm._v(" 写评论 ")]) : _vm._e(), _c("div", {
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("comment-add", {
    ref: "commentAdd",
    attrs: {
      "ass-id": _vm.assId,
      "ass-type": _vm.assType
    },
    on: {
      refresh: _vm.getCommentList
    }
  }), _vm._l(_vm.commentList, function (comment) {
    return _c("div", {
      key: comment.id,
      staticClass: "comment-item",
      on: {
        click: function ($event) {
          return _vm.handleCommentAdd(comment);
        }
      }
    }, [_c("div", {
      staticClass: "content"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(_vm.getCommentTitle(comment)) + "： ")]), _c("span", {
      staticClass: "comment-text"
    }, [_vm._v(_vm._s(comment.content))])]), comment.fileList.length > 0 ? _c("div", {
      staticClass: "attach flex m-t-10px m-b-10px"
    }, [_c("p", [_vm._v("附件：")]), _c("div", {
      staticClass: "flex flex-1 flex-wrap"
    }, _vm._l(comment.fileList, function (item) {
      return _c("file-preview", {
        key: item.path,
        staticStyle: {
          "margin-right": "20px"
        },
        attrs: {
          "file-path": item.path
        },
        on: {
          click: function ($event) {
            $event.stopPropagation();
          }
        }
      }, [_vm._v(" " + _vm._s(item.name) + ", ")]);
    }), 1)]) : _vm._e(), _c("div", {
      staticClass: "footer"
    }, [_c("span", {
      staticClass: "time"
    }, [_vm._v(_vm._s(comment.createTime))]), _c("span", {
      staticClass: "operation"
    }, [_c("a-icon", {
      attrs: {
        type: "message"
      }
    })], 1)])]);
  }), _vm.page.total && _vm.page.total !== 5 ? _c("a-pagination", {
    staticClass: "m-m-t-8 m-m-b-8",
    attrs: {
      total: _vm.page.total,
      "page-size": _vm.pageSize,
      "show-total": total => `共${total}条评论`
    },
    on: {
      change: _vm.getCommentList
    },
    model: {
      value: _vm.page.pageNo,
      callback: function ($$v) {
        _vm.$set(_vm.page, "pageNo", $$v);
      },
      expression: "page.pageNo"
    }
  }) : _vm._e()], 2)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;